__turbopack_context__.v({
  "base": "SchemaLess-module__p0OIrq__base",
  "baseinner": "SchemaLess-module__p0OIrq__baseinner",
  "content": "SchemaLess-module__p0OIrq__content",
  "inside": "SchemaLess-module__p0OIrq__inside",
  "tableHeader": "SchemaLess-module__p0OIrq__tableHeader",
  "tableWrapper": "SchemaLess-module__p0OIrq__tableWrapper",
  "title": "SchemaLess-module__p0OIrq__title",
  "wrapper": "SchemaLess-module__p0OIrq__wrapper",
});
